import React, { FunctionComponent, useMemo } from 'react';
import { Box } from '@material-ui/core';
import useScrollToSection from '../../../hooks/navigation/useScrollToSection';
import customTitleStyles from './CustomTitleStyles';

export interface ICustomTitleProps {
  title: string;
  indicative: string;
}

const CustomTitle: FunctionComponent<ICustomTitleProps> = ({ title, indicative }) => {
  const styles = customTitleStyles();

  const { scrollToDisclaimer } = useScrollToSection();
  const hasIndicativeNumber = useMemo(() => title.includes(indicative), [title]);

  if (!hasIndicativeNumber) {
    return <>{title}</>;
  }

  return (
    <>
      {title.replace(indicative, '')}
      <Box component={'span'} onClick={scrollToDisclaimer} data-test={'title:indicative'} className={styles.indicative}>
        {indicative}
      </Box>
    </>
  );
};

export default CustomTitle;
